import { render, staticRenderFns } from "./PreSales.vue?vue&type=template&id=90ff5784"
import script from "./PreSales.vue?vue&type=script&lang=js"
export * from "./PreSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports